import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-el-icon-error",
  "use": "icon-el-icon-error-usage",
  "viewBox": "0 0 18 18",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 18 18\" id=\"icon-el-icon-error\">\r\n    <path id=\"icon-el-icon-error_error-circle-filled\" fill-rule=\"evenodd\" transform=\"translate(1.125 1.125)  rotate(0 7.875 7.875)\" opacity=\"1\" d=\"M0 7.88C0 12.22 3.53 15.75 7.88 15.75C12.22 15.75 15.75 12.22 15.75 7.88C15.75 3.53 12.22 0 7.88 0C3.53 0 0 3.53 0 7.88Z M8.44 3.38L7.31 3.38L7.31 9.56L8.44 9.56L8.44 3.38Z M7.19 11.25L7.19 12.6L8.54 12.6L8.54 11.25L7.19 11.25Z \" />\r\n\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol